<template>
  <layout-header v-if="!isNotFound"></layout-header>
  <router-view />
  <layout-footer v-if="!isNotFound"></layout-footer>
</template>

<script setup>
  import LayoutHeader from "@/components/LayoutHeader";
  import LayoutFooter from "@/components/LayoutFooter";
  import { onMounted, computed } from "vue";
  import { useRoute } from 'vue-router';
  const route = useRoute();
  const isNotFound = computed(() => route.name === 'NotFound');

  onMounted(() => {
    let param = "",param_new = ""
      , param_index = window.location.href.indexOf("?");
    -1 != param_index && (param = "&".concat(window.location.href.slice(window.location.href.indexOf("?") + 1)));
    let pathname = "";
    function pushToDataLayer(message, hiddenValue) {
      "event" == hiddenValue ? "undefined" != typeof window && window?.dataLayer && window.dataLayer.push({
        event: "open_demat_account_popup_click"
      }) : "undefined" != typeof window && window?.dataLayer && window.dataLayer.push({
        event: "sign_up_click",
        cta_text: "Sign up",
        status: hiddenValue,
        message_text: message
      })
    }
    function validateMobile(mobileNumber, data) {
      const hiddenInput = data.querySelector('input[type="hidden"]')
        , hiddenValue = hiddenInput ? hiddenInput.value : "failed";
      return "" == mobileNumber ? (data.getElementsByClassName("error-message")[0].innerHTML = "<span>Enter your mobile number to sign up</span>",
        "failed" == hiddenValue && pushToDataLayer("Enter your mobile number to sign up", hiddenValue),
        !1) : /^(6|7|8|9)\d{9}$/.test(mobileNumber) && !mobileNumber.startsWith("0") || (data.getElementsByClassName("error-message")[0].innerHTML = "<span>Please enter valid mobile no.</span>",
          "failed" == hiddenValue && pushToDataLayer("Please enter valid mobile no.", hiddenValue),
          !1)
    }
    function isNumber(evt) {
      const charCode = (evt = evt || window.event).which ? evt.which : evt.keyCode;
      return !(charCode > 31 && (charCode < 48 || charCode > 57))
    }
    function setCookie(cname, cvalue, secs) {
      document.cookie = cname + "=" + cvalue + ";max-age=" + secs + ";path=/;domain=.upstox.bond;SameSite=strict;Secure"
    }
    function proceedWithLazyLogin(event, data) {
      event.preventDefault();
      const phone = data.elements[0].value
        , id = data.elements[0].id;
      if (param_new = "dark" == id ? "_dark" : "light" == id ? "_light" : param,
        validateMobile(phone, data)) {
        data.getElementsByClassName("error-message")[0].innerHTML = "",
          setCookie("lead_phone_number", phone, 300);
        const hiddenInput = data.querySelector('input[type="hidden"]');
        pushToDataLayer("success", hiddenInput ? hiddenInput.value : "success"),
          location.href = "https://wa.me/+917092362098"
      }
    }
    window.proceedWithLazyLogin = proceedWithLazyLogin
    window.isNumber = isNumber
  })
</script>

<style lang="scss">
  @import url(~@/styles/2-layouts/common.scss)
</style>